import React from "react";
import { useNavigate } from "react-router-dom";
import { ResetPasswordForm } from "../components/reset_password_form";
import AuthHeader from "../components/auth_header";

import { IconArrowLeft } from "@tabler/icons-react";
import { AppRoutes } from "../../../../common/routes/app_routes";
import { Button } from "../../../../components/common/button";

const ResetPasswordPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-full min-h-screen bg-bgDefault text-textPrimary p-6">
      <div className="relative w-full max-w-4xl mx-auto">
        <Button
          variant="ghost"
          size="sm"
          aria-label="Back"
          leftIcon={<IconArrowLeft size={20} />}
          onClick={() => navigate(AppRoutes.LOGIN)}
        />

        <div className="flex flex-col items-center w-full">
          <div className="mb-16">
            <AuthHeader />
          </div>

          <div className="w-full max-w-[500px] bg-bgDefault rounded-[12px] p-6">
            <div className="flex flex-col justify-center items-center w-full">
              <p className="text-white text-lg mb-6">Reset your password</p>
              <ResetPasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
